var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 62,
    viewBox: "0 0 51 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 32C30.6624 32.851 30.4687 33.6903 30.0997 34.4571C29.7307 35.2239 29.1957 35.899 28.5333 36.4333L11.5333 50.4667C10.5099 51.2867 9.27668 51.8027 7.97423 51.9559C6.67178 52.1092 5.35248 51.8934 4.16667 51.3333C3.13609 50.8791 2.25805 50.1378 1.63741 49.1979C1.01678 48.2581 0.679782 47.1595 0.666671 46.0333L0.66667 17.9667C0.67978 16.8405 1.01678 15.7419 1.63741 14.8021C2.25805 13.8622 3.13609 13.1209 4.16667 12.6667C5.35248 12.1066 6.67178 11.8908 7.97423 12.0441C9.27668 12.1973 10.5099 12.7133 11.5333 13.5333L28.5333 27.5667C29.1957 28.101 29.7307 28.7761 30.0997 29.5429C30.4687 30.3097 30.6624 31.149 30.6667 32Z",
    fill: "#79889A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 3.5H47V58.5H34.5",
    stroke: "#79889A",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxMinimize);
export default __webpack_public_path__ + "static/media/max-minimize.c3b2c6f3370ebd416e6d596a876b78e6.svg";
export { ForwardRef as ReactComponent };